import api from '../api';
import { SA_SEARCH_PERFORMED } from '../constants/analyticEvents';
import { pushEvent } from './analytics';

export function sendSearchPerformed(minPrice) {
  // send data to serchPerformed
  const userData = JSON.parse(localStorage.getItem('hf_user'));
  if (userData && userData.user?.muid && userData.user?.email && sessionStorage.getItem('hfLastFilters')) {
    api.sendSearchPerformed({
      "muid": userData?.user?.muid,
      "price": minPrice,
      "hfLastFilters": JSON.parse(sessionStorage.getItem('hfLastFilters'))
    });
    pushEvent(SA_SEARCH_PERFORMED, { muid: userData?.user?.muid, price: minPrice });
  }
}
